<template>
	<div class="warp">
		<div>
			<img src="../../assets/img/public/404.png" alt="404" class="img">
			<div class="title1">糟糕！有些不对劲…</div>
			<div class="title2">页面找不到了</div>
			<div class="title3">请检查您输入的网址是否正确，或点击下面的按钮返回首页</div>
			<el-button class="btn" type="primary" @click="goHome()">返回首页</el-button>
		</div>
	</div>
</template>

<script>
  export default {
    name: 'Page404',
    data() {
      return {
        jumpTime: 5,
        timer: 0,
      }
    },
    mounted() {
      //this.timeChange()
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    methods: {
      timeChange() {
        this.timer = setInterval(() => {
          if (this.jumpTime) {
            this.jumpTime--
          } else {
            this.$router.push({ path: '/' })
            clearInterval(this.timer)
          }
        }, 1000)
      },
	  goHome(){
            this.$router.push({ path: '/' })
	  }
    },
  }
</script>

<style scoped>
	.warp{
		width: 100vw;
		height: 100vh;
		font-family: PingFang-SC-Medium, PingFang-SC;
		color: #333333;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}
	.img{
		width: 400px;
	}
	.title1{
		font-size: 26px;
		margin-top: 53px;
	}
	.title2{
		font-size: 48px;
		margin-top: 10px;
	}
	.title3{
		font-size: 14px;
		margin-top: 10px;
	}
	.btn{
		width: 110px;
		height: 40px;
		background: #0486FE;
		font-size: 14px;
		color: #FFFFFF;
		margin: 0 auto;
		margin-top: 30px;
	}
</style>
